// extracted by mini-css-extract-plugin
export default {"innerWrapper":"kC-z","tooltipWrapper":"lC-z","icon":"mC-z","tooltip":"nC-z","content":"oC-z"};